import { Box } from '@mui/material'
import type { FC } from 'react'

interface CounterOverlayProps {
    value: number
    animated?: boolean
}

export const CounterOverlay: FC<CounterOverlayProps> = ({ value, animated }) => {
    return (
        <Box
            className="counter-overlay"
            sx={{
                zIndex: 100,
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                transformOrigin: 'center',
                animation: animated ? 'counterAppear 0.75s ease-out forwards' : 'none',

                '@keyframes counterAppear': {
                    '0%': { opacity: 0, transform: 'scale(0.5)' },
                    '60%': { opacity: 1, transform: 'scale(1.15)' },
                    '100%': { opacity: 1, transform: 'scale(1)' },
                },
            }}
        >
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid meet"
                style={{ overflow: 'visible', transformOrigin: 'center' }}
            >
                <text
                    x="50"
                    y="48"
                    textAnchor="middle"
                    dominantBaseline="central"
                    fill="white"
                    fontSize="30px"
                    fontWeight="bold"
                    fontFamily="inherit"
                    style={{
                        filter: 'drop-shadow(1px 2px 2px black)',
                        fontVariantNumeric: 'tabular-nums',
                    }}
                >
                    {value}
                </text>
            </svg>
        </Box>
    )
}
